export default function Notary() {
  return (
    <div className="container-narrow">
      <div className="card">

        {/* Hero Section */}
        <div
          style={{
            background: "linear-gradient(135deg, #2f6f89, #4f9ab4)",
            padding: "40px 28px",
            borderRadius: "18px",
            marginBottom: "32px",
            textAlign: "center",
            color: "#ffffff"
          }}
        >
          <img
  src="/favicon.png"
  alt="Hopeful Horizons NY Logo"
  style={{
    height: "70px",
    marginBottom: "10px"
  }}
/>

          <h1 style={{ margin: "10px 0 12px 0" }}>Notary Services</h1>

         <p
  style={{
    maxWidth: "600px",
    margin: "0 auto",
    lineHeight: "1.6",
    color: "#ffffff"
  }}
>
  Convenient, professional notary support for individuals, families,
  providers, and OPWDD-related paperwork.
</p>

          <a
            href="https://outlook.office.com/book/NotaryServicesHopefulHorizonsNY@NETORG20608407.onmicrosoft.com/?ismsaljsauthenabled"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-block",
              marginTop: "20px",
              padding: "14px 22px",
              background: "#ffffff",
              color: "#2f6f89",
              textDecoration: "none",
              borderRadius: "10px",
              fontWeight: "600"
            }}
          >
            Book an Appointment
          </a>
        </div>

        {/* Info Cards */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
            gap: "20px",
            marginBottom: "32px"
          }}
        >
          {/* Documents */}
          <div
            style={{
              padding: "24px",
              borderRadius: "14px",
              background: "#f4f8fb",
              border: "1px solid #dbe8ef",
              color: "#000"
            }}
          >
            <h2 style={{ marginBottom: "12px" }}>Common Documents</h2>

            <p style={{ lineHeight: "1.7", margin: 0 }}>
              Affidavits, consent forms, applications, OPWDD-related paperwork,
              service-related documents, and general notary documents.
            </p>
          </div>

          {/* Before You Arrive */}
          <div
            style={{
              padding: "24px",
              borderRadius: "14px",
              background: "#fffaf2",
              border: "1px solid #f0dfbf",
              color: "#000"
            }}
          >
            <h2 style={{ marginBottom: "12px" }}>Before You Arrive</h2>

            <p style={{ lineHeight: "1.7", margin: 0 }}>
              Bring a valid photo ID and your document. Do not sign the document
              in advance unless specifically instructed by the notary.
            </p>
          </div>
        </div>

        {/* Calendar Section */}
       

        {/* Footer Note */}
        <p style={{ marginTop: "24px", color: "#000", lineHeight: "1.6" }}>
          Questions before booking? Contact Hopeful Horizons NY for assistance (support@hopefulhorizonsny.com)
        </p>

      </div>
    </div>
  );
}